export const stepIndicatorDatalocator = {
    step_heading: 'step_heading'
};
